import React, {Component} from 'react';
import './AuthLoginScreen.css';
import ArrowLink from "../Common/ArrowLink";
import RmField from "../Forms/RmField";
import RmButton from "../Common/RmButton";
import AuthScreen from "./AuthScreen";
import axios from 'axios';
import ErrorMessage from "../Common/ErrorMessage";
import {Redirect} from 'react-router-dom';

export default class AuthLoginScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attemptingLogin: false,
            email: "",
            password: "",
            errorMessage: null,
            redirecting: false
        };
    }

    handleButtonClick() {
        if (this.state.attemptingLogin) {
            return;
        }

        this.submitLogin(this.state.email, this.state.password);
    }

    handleEmailChange(value) {
        this.setState({
            email: value,
            errorMessage: null
        });
    }

    handlePasswordChange(value) {
        this.setState({
            password: value,
            errorMessage: null
        });
    }

    submitLogin() {
        this.setState({
            attemptingLogin: true,
            errorMessage: null
        });

        let payload = {
            email: this.state.email,
            password: this.state.password
        };

        axios.post("/login", payload)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        redirecting: true
                    });
                } else {
                    this.setState({
                        errorMessage: data.message || "Controleer de ingevoerde gegegevens."
                    });
                }
            })
            .catch((err) => {
                console.error('Login failure caught:', err);

                this.setState({
                    errorMessage: "Er ging iets mis bij het inloggen. Probeer het opnieuw."
                });
            })
            .then(() => {
                this.setState({
                    attemptingLogin: false
                });
            });
    }

    render() {
        if (this.state.redirecting) {
            return <Redirect to='/'/>;
        }

        return (
            <AuthScreen title={"Inloggen bij de planning tools"}>
                <p className={"AuthLoginScreen__intro"}>
                    Heeft u al een account voor de <a href="https://www.rememberme.nl/planning-tools" target={"_blank"} title={"Meer informatie"}>planning tools van RememberMe</a>? Dan kunt u inloggen door onderstaande gegevens in te vullen.
                </p>

                <div>
                    <RmField id={"email"} label={"Vul hier uw e-mail adres in..."} iconName={"email-outline"}
                             inputType={"email"} disabled={!!this.state.attemptingLogin}
                             value={this.state.email} onChange={this.handleEmailChange.bind(this)}
                    />
                    <RmField id={"password"} label={"Vul hier uw wachtwoord in..."} iconName={"key-variant"}
                             inputType={"password"} disabled={!!this.state.attemptingLogin}
                             value={this.state.password} onChange={this.handlePasswordChange.bind(this)}
                    />
                </div>

                {this.state.errorMessage &&
                <ErrorMessage message={this.state.errorMessage}/>
                }

                <div className={"AuthLoginScreen__submit"}>
                    <RmButton label={"Inloggen"} busy={!!this.state.attemptingLogin}
                              onClick={this.handleButtonClick.bind(this)}/>
                </div>

                <hr className={"AuthLoginScreen__sep"}/>

                <div className={"AuthLoginScreen__extras"}>
                    <ArrowLink label={"Aanmelden voor nieuw account"} href={"/aanmelden"}/>
                    <ArrowLink label={"Wachtwoord vergeten"} href={"/wachtwoord"}/>
                </div>
            </AuthScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthLoginScreen.js